import moment from "moment";
import { axiosGet, axiosPost } from "../../apis/useAxios";

// Crew Feedback › Rating. Only this page's own API (rating/*).

const airlineCode = () => sessionStorage.getItem("session_airlineCode") ?? "";
const userName = () => sessionStorage.getItem("session_userName") ?? "";

/** The airline's ratings from `from` to `to` (Date, whole days), newest first. */
export async function getRatings({ from, to }, options) {
  const response = await axiosGet(
    "rating/list",
    { airlineCode: airlineCode(), from: moment(from).format("YYYY-MM-DD"), to: moment(to).format("YYYY-MM-DD") },
    options,
  );
  if (!response || (response.isSuccess === false && !/no record/i.test(response.message ?? ""))) {
    throw new Error(response?.message || "Unable to load the ratings.");
  }
  return response.payload ?? [];
}

/** Saves the reply the crew member sees in the crew app. */
export function replyToRating({ id, replyMsg }) {
  return axiosPost("rating/reply", { airlineCode: airlineCode(), userName: userName(), id, replyMsg });
}
